<template>
  <div class='time-updater'>
    <div v-if='error'>
      {{error}}
    </div>
    <v-container v-else>
      <v-row>Updating times for <b> {{profile.solverName}} </b> (WCA: <b>{{profile.wcaID}}</b>)</v-row>
      <v-row><b>All times are in milliseconds. Compatible metadata values are: 'ok', '+2', 'dns', 'dnf', 'dq'.</b></v-row>
      <v-row v-for='(result, i) in results' :key='i'>
        <span>{{i}}</span>
        <v-text-field v-model='results[i].time' number></v-text-field>
        <v-text-field v-model='results[i].metadata'></v-text-field>
        <span> <b>OPEN:</b> {{ results[i].openTime }} </span>
        <span> <b>SUBMIT:</b> {{ results[i].submitTime }} </span>
        <v-btn @click='updateResult(i)'>UPDATE</v-btn>
      </v-row>
      <v-btn @click='clearResults'>CLEAR TIMES</v-btn>
    </v-container>
  </div>
</template>

<script>
import AdminService from '@/services/TPC/AdminService'
import RoundsService from '@/services/TPC/RoundsService'

export default {
  name: 'time-updater',
  data () {
    return {
      profile: {},
      results: [],
      error: '',
    }
  },
  props: {
    roundID: String,
    profileID: Number,
  },
  methods: {
    async updateResult (i) {
      const {data} = await AdminService.updateResult({
        roundID: this.roundID,
        profileID: this.profileID,
        scrambleNum: i,
        result: this.results[i],
      })
      if (data.error) {
        alert(`Error: ${data.error} - ${data.message}`)
      } else {
        alert('Success')
      }
    },
    async clearResults () {
      let confirmation = confirm('This will remove all the results for this solver. ONLY DO THIS IF YOU WANT THE SOLVER TO RESUBMIT THEIR RESULTS. Are you sure?')
      if (!confirmation) return
      const {data} = await AdminService.clearResults({
        roundID: this.roundID,
        profileID: this.profileID,
      })
      if (data.error) {
        alert(`Error: ${data.error} - ${data.message}`)
      } else {
        alert('Success')
      }
    },
  },
  async created () {
    if (!this.roundID || !this.profileID) {
      this.error = `Couldn't find roundID/profileID (got ${this.roundID}, ${this.profileID})`
      return
    }
    const {data: resultsData} = await RoundsService.listResults('solver', {
      roundID: this.roundID,
      profileID: this.profileID
    })
    if (resultsData.error) {
      this.error = `Error: ${resultsData.error} - ${resultsData.message}`
    } else {
      console.log(resultsData)
      this.profile = resultsData
      this.results = resultsData.solveTimes
    }
  }
}
</script>
